
<div mat-dialog-title>Import Blended Models<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  @if (hasFile && !isValidFile) {
    <mat-card class="error block">
      <mat-card-title class="error">{{invalidFileErrorHeader}}</mat-card-title>
      <mat-card-subtitle>{{invalidFileErrorMessage}}</mat-card-subtitle>
    </mat-card>
  }
  @if (errorMessage) {
    <mat-card class="error block">
      <mat-card-title class="error">An error occurred.</mat-card-title>
      <mat-card-subtitle>{{errorMessage}}</mat-card-subtitle>
    </mat-card>
  }
  <div>In addition to securities and targets, rebalancing bands can be imported. The word "global" can be used in both the Minimum Percent and Maximum Percent columns. If this is present in both columns, or if these data points are left blank, global rebalancing bands will be applied to those imported security targets.</div>
  <div>
    <table class="import" width="100%">
      <tr>
        <th align="left" style="vertical-align: top;"><label>File name</label></th>
        <td>
          <div class="bottomPaddingElementDialog">
            <irb-file-selector (change)="onFileChange($event)"></irb-file-selector>
            <div>File type must be .csv</div>
          </div>
        </td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>Instructions</label></th>
        <td><div class="block">Your selected file must be in .csv format and follow iRebal's format: Blended Model Name, Blended Model Description (optional), Component Security Model Name, Target Percentage (expressed in whole # - can go out to one decimal place).
        </div></td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>Template</label></th>
        <td>
          <div>Use our .csv template to prepare your file.<br/>
            <a href="/assets/template/Blended Models.xlsx">Download template: Blended Models.xlsx</a></div>
          </td>
        </tr>
      </table>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="submitFile()" [disabled]="!(hasFile && isValidFile && !errorMessage)"
      class="btn-medium-primary">Continue
    </button>
  </mat-dialog-actions>
